import PhotoModalCloseButton from '../src/PhotoModalCloseButton.tsx';
export default PhotoModalCloseButton;
